module.exports = __webpack_public_path__ + "img/recipe.4bdc630e.png";